import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/toPromise';
import { SxHttpService } from 'app/infrastructure/services/sxHttp.service';
import { Categories } from '../model/interfaces/categories.interface';

@Injectable()
export class CategoryService {

    url: string = "api/category/";
    public sourceCategories: Categories = null; //is and auxiliar chache category to cancel or aply changes

    constructor(private sxHttp: SxHttpService) { }

    getCategoriesList(context: any): Observable<Categories> {
        const request$ = this.sxHttp.post(this.url + "GetAll", context)

        return request$.map(result => {
            let response = result.json().data as Categories
            return response;
        });
    }

    checkOrganization(value: boolean) {
        if (this.sourceCategories !== null) {
            this.sourceCategories.organizations.forEach(category => {
                category.isSelected = value;
            });
        }
    }

    checkSubcription(value: boolean) {
        if (this.sourceCategories !== null) {
            this.sourceCategories.subscriptions.forEach(category => {
                category.isSelected = value;
            });
        }
    }

    checkCountry(value: boolean) {
        if (this.sourceCategories !== null) {
            this.sourceCategories.countries.forEach(category => {
                category.isSelected = value;
            });
        }
    }

    checkRegion(value: boolean) {
        if (this.sourceCategories !== null) {
            this.sourceCategories.regions.forEach(category => {
                category.isSelected = value;
            });
        }
    }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/infrastructure/services/category.service.ts